import API from 'services/api';

import { IPartnerCancellationPolicy } from '../models';

interface IUpsertPartnerCancellationPolicy {
  partnerId?: number;
  policyId?: string;
  payload: IPartnerCancellationPolicy;
}

export const upsertPartnerCancellationPolicy = ({
  partnerId,
  policyId,
  payload,
}: IUpsertPartnerCancellationPolicy) => {
  if (!!policyId) {
    return API.put(`/api/accommodation/cancellation-policy/${policyId}`, payload);
  } else {
    return API.post(`/api/accommodation/cancellation-policy/partneri/${partnerId}`, payload);
  }
};
